import mapKeys from 'lodash/mapKeys';

function randomAlphaNumeric(length: number): string {
  const ALPHA_NUMERIC_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const { length: charLength } = ALPHA_NUMERIC_CHARSET;

  const values = crypto.getRandomValues(new Uint32Array(length));

  return Array.from(values, rand => {
    return ALPHA_NUMERIC_CHARSET[rand % charLength];
  }).join('');
}

function randomNumberRange(from: number, to: number): number {
  const values = crypto.getRandomValues(new Uint32Array(1));

  const value = values[0] / (0xffffffff + 1);

  const min = Math.ceil(from);
  const max = Math.floor(to);

  return Math.floor(value * (max - min + 1)) + min;
}

function parseSearchParams(search: string): Dictionary<string> {
  return Object.fromEntries(new URLSearchParams(search));
}

function setURLQueryParams(url: string, params: Dictionary<never>): string {
  const result = new URL(url);

  Object.entries(params).forEach(([key, val]) => {
    result.searchParams.set(key, String(val));
  });

  return result.toString();
}

function buildLocationHostUrl(): string {
  const { host, pathname } = window.location;

  return `${host}${pathname}`;
}

function filterObject<T>(obj: Dictionary<T>, keys: Array<string>): Dictionary<T> {
  const result: Dictionary<T> = {};

  keys.forEach(key => {
    if (!(key in obj)) {
      return;
    }

    result[key] = obj[key];
  });

  return result;
}

function convertObjectKeys<T>(obj: Dictionary<T>, keysDict: Dictionary<string>): Dictionary<T> {
  return mapKeys(obj, (_, key) => keysDict[key] || key);
}

export {
  randomAlphaNumeric,
  randomNumberRange,
  parseSearchParams,
  setURLQueryParams,
  filterObject,
  convertObjectKeys,
  buildLocationHostUrl,
};
